




















































import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import users from '@/store/modules/users';
import statistics from '../store/modules/statistics';
import { dateStr, controllerEventTypeIdToString, controllerEventTypeIdToColorClass } from '@/store/common';
import addresses from '../store/modules/addresses';
import store from '../store/store';

@Component({
  components: {},
  methods: {
    dateStr,
    controllerEventTypeIdToString,
    controllerEventTypeIdToColorClass,
  },
})
export default class VEvents extends Vue {
  private alerts: Array<{type: string, msg: string}> = [];
  private inprogress: boolean = false;

  get loggedIn() {
    return store. getters.loggedIn;
  }

  private beforeMount() {
    if (!store.getters.loggedIn) {
      router.replace('/login');
    } else {
      this.inprogress = true;
      statistics.getControllerEvents({uid: store.getters.user.id, seen: 0})
        .then((events) => {
          // if (addrs && addrs.length != 0) {}
        })
        .catch((error: any) => {
          this.alerts.push({type: 'error', msg: 'Не удалось получить список событий.'});
        })
        .finally(() => {
          this.inprogress = false;
        });
    }
  }

  // private created() {
  //   this.inprogress = true;
  //   if (store.getters.loggedIn) {
  //     addresses.refreshAddresses(store.getters.user.id)
  //     .catch((error: any) => {
  //       //  console.log(error);
  //     })
  //     .finally(() => {
  //       this.inprogress = false;
  //     });
  //   }
  // }

  get ctrlEvents() {
    return statistics.theControllerEvents;
  }
}
